export interface TierDotProps {
  /** Base hex color, e.g. "#E5A015". Border and glow are derived via
   * color-mix(), so CSS variables are supported as well.
   */
  color: string;
}

/**
 * TierDot — крошечный (6×6) ореол-индикатор для строк odds-таблицы.
 * Цвет передаётся caller'ом. DS override через --co-TierDot-baseColor;
 * без override — используется значение `color` prop как fallback.
 * Border и glow вычисляются через color-mix(), что поддерживает CSS vars.
 *
 * Выделено из modules/odds/OddsPanel.tsx (вместе с tierStyles.ts mapping).
 */
export function TierDot({ color }: TierDotProps) {
  const resolvedColor = `var(--co-TierDot-baseColor, ${color})`;
  return (
    <span
      aria-hidden
      data-co-component="TierDot"
      className="size-[6px] shrink-0 rounded-full border-2"
      style={{
        backgroundColor: resolvedColor,
        borderColor: `color-mix(in srgb, ${resolvedColor} 20%, transparent)`,
        boxShadow: `0 0 4px 0 color-mix(in srgb, ${resolvedColor} 30%, transparent), inset 0 0 7px 0 color-mix(in srgb, ${resolvedColor} 60%, transparent)`,
      }}
    />
  );
}
